import React, { useEffect, useState } from 'react';
import Footer from '../../components/Common/Footer';
import Dialogs from '../../components/Common/Dialog';
import { goToTopOfPage } from '../../helper/helper';
import { useNavigate } from 'react-router-dom';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import ThankYou from '../../components/Common/ThankYou';
import Heading from '../../components/Common/Heading';
import PlanPurchase from '../../components/Common/PlanPurchase';
import { cancelUserSubscription } from './services/MyPlan.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import UserPlanDetails from './components/UserPlanDetails';
import { PlanDetailsModel } from '../../interfaces/plan.interface';

const MyPlans = () => {
  const user = useSelector((state: RootState) => state.user.user);

  const navigate = useNavigate();
  const [showThanksNote, setShowThanksNote] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [currentPlanDescription, setCurrentPlanDescription] = useState<PlanDetailsModel | null | undefined>(null);
  const [loader, setLoader] = useState({
    removeSubscription: false
  });

  useEffect(() => {
    goToTopOfPage();
  }, []);

  useEffect(() => {
    setCurrentPlanDescription(user?.plan);
  }, [user]);

  const handleCancelSubscription = async () => {
    setOpenDialog(false);
    setLoader((prev) => ({ ...prev, removeSubscription: true }));
    const response = await cancelUserSubscription(user?.email || '');
    setLoader((prev) => ({ ...prev, removeSubscription: false }));
  };

  const goBack = () => {
    navigate(-1);
    setShowThanksNote(false);
  };

  return (
    <div className="App">
      <NavigationBar />
      <div className="bg-storytan p-4 mx-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {showThanksNote ? (
            <ThankYou goBack={goBack} />
          ) : (
            <>
              <div className="flex justify-between items-baseline">
                <div className=" flex items-center align-end mb-2">
                  <Heading title="My Plan" />
                </div>
                <button
                  className="bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 py-2 text-sm"
                  onClick={() => {
                    navigate(-1);
                  }}
                >Back
                </button>
              </div>

              <div className="flex-col mt-8 w-full flex md:flex-row  gap-4 justify-between text-start">
                <UserPlanDetails
                  user={user}
                  loader={loader}
                  setOpenDialog={setOpenDialog}
                  currentPlanDescription={currentPlanDescription}
                />

                <div className=" sm:w-[100%] md:w-[50%] m-0">
                  <PlanPurchase setShowThanksNote={setShowThanksNote} />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer className="mb-0 pb-4" />
      <Dialogs
        openDialog={openDialog}
        handelClose={() => setOpenDialog(false)}
        handelProcess={handleCancelSubscription}
        confirmMessage="Are you sure you want to cancel Subscription? If subscription cancelled, you may no longer have access to the books you created."
      />
    </div>
  );
};
export default MyPlans;
